/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import { css, useTheme } from '@emotion/react'
import { Button, Link } from '../base-ui'
import { MediaQuery } from '../base-ui/Utility'
import { GiHamburgerMenu } from 'react-icons/gi'
import { CgCloseR } from 'react-icons/cg'
import { useDataProvider } from '../../hooks/dataProvider'
import { useTranslation } from 'next-i18next'
import ChangeLanguage from './ChangeLanguage'
import { useUser } from '../../hooks/User'

// import { useDataProvider } from '../../hooks/dataProvider'
/* eslint-disable indent */

function Navbar() {
    const theme = useTheme()
    const router = useRouter()
    const [visible, setVisible] = useState(false)
    // const [bgColor, setBgColor] = useState(false)
    // const changeBg = () => {
    //     if (window.scrollY >= 80) {
    //         setBgColor(true)
    //     } else {
    //         setBgColor(false)
    //     }
    // }
    // window.addEventListener('scroll', changeBg)
    // const bgSticky = '#333333ef'
    const { data } = useDataProvider()
    const homeNavbar = data?.homeNav
    const { t } = useTranslation(['common'])
    const user = useUser()

    const showDrawer = () => {
        setVisible(true)
    }
    const onClose = () => {
        setVisible(false)
    }
    const menuStyle = `
        a {
            padding: 0 0.25rem;
            font-weight: 600;
        };
        border-radius: ${theme.borderRadius.default};
        &:hover {
            background-color: ${theme.colors.secondary}; 
        }

    `
    return (
        <>
            <div
                className={`lg:hidden w-screen h-screen -top-0 bg-gray-600 bg-opacity-20 z-20 backdrop-filter backdrop-blur-sm ${visible ? 'block' : 'hidden'
                    }`}
                css={css`
                    right: 0;
                    left: auto;
                    position: fixed;
                `}
            >
                <div
                    className={`slideMenu w-64 bg-white float-left px-6 h-full
            ${visible ? 'slideEnter' : 'hidden'}`}
                >
                    <button className="mt-4 w-8" onClick={onClose}>
                        <CgCloseR
                            css={css`
                                font-size: ${theme.fontSize.x2l};
                                color: ${theme.colors.secondaryLight};
                            `}
                        />
                    </button>
                    <div className="mt-10">
                        {user.isLoggedIn && (
                            <>
                                <Button
                                    href="/dashboard"
                                    type="linkButton"
                                    color="secondary"
                                    size="small"
                                    backgroundColor="primary"
                                    style={
                                        'padding-right: 0.5rem; padding-left: 0.5rem;'
                                    }
                                >
                                    {t('dashboard')}
                                </Button>
                                <span className="mr-4 ml-4">|</span>
                                <Button
                                    href="/api/auth/signout"
                                    type="linkButton"
                                    color="lighterGray"
                                    size="small"
                                    backgroundColor="secondary"
                                    style={
                                        'padding-right: 0.5rem; padding-left: 0.5rem;'
                                    }
                                >
                                    {t('signout')}
                                </Button>
                            </>
                        )}
                        {!user.isLoggedIn && (
                            <Button
                                href="/auth/signin"
                                type="linkButton"
                                color="lighterGray"
                                size="small"
                                backgroundColor="secondary"
                                style={
                                    'padding-right: 0.5rem; padding-left: 0.5rem;'
                                }
                            >
                                {t('login')}
                            </Button>
                        )}
                    </div>

                    <ul
                        className="mt-10 capitalize"
                        css={css`
                            a {
                                border-bottom: 3px solid
                                    ${theme.colors.secondaryLight};
                                padding: 0.25rem;
                                color: ${theme.colors.secondary};
                            }
                        `}
                    >
                        <li className="mb-10">
                            <Link href="/" onClick={onClose}>
                                {t('home')}
                            </Link>
                        </li>
                        <li className="mb-10">
                            <Link href="/brokers" onClick={onClose}>
                                {t('brokers')}
                            </Link>
                        </li>
                        <li className="mb-10">
                            <Link href="/charts" onClick={onClose}>
                                {t('charts')}
                            </Link>
                        </li>
                        <li className="mb-10">
                            <Link href="/blog" onClick={onClose}>
                                {t('blog')}
                            </Link>
                        </li>
                        <li className="mb-10">
                            <Link href="/about" onClick={onClose}>
                                {t('about us')}
                            </Link>
                        </li>
                        <li className="mb-10">
                            <Link href="/contact" onClick={onClose}>
                                {t('contact us')}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <header
                className="flex py-4 px-6 lg:px-20 xl:px-28 2xl:px-52 items-center w-full"
                css={css`
                    z-index: 9;
                    top: 0;
                    ${homeNavbar &&
                    'position: fixed; left: 50%; transform: translate(-50%, 0); background-color: #e9e9e985; backdrop-filter: blur(10px)'};
                    ${!homeNavbar &&
                    `position: sticky; background-color: ${theme.colors.mainBackground}; margin: 0 auto;`};
                `}
            >
                <div className="flex justify-between">
                    <div
                        css={css`
                            display: flex;
                            gap: 10px;
                            ${MediaQuery('lg', 'min')} {
                                display: none;
                            }
                        `}
                    >
                        <Button
                            onClick={showDrawer}
                            color="secondary"
                            backgroundColor="primary"
                        >
                            <GiHamburgerMenu />
                        </Button>
                        <ChangeLanguage />
                    </div>

                    <div
                        className="hidden lg:flex items-center justify-center"
                        css={css`
                            color: ${homeNavbar
                                ? theme.colors.lighterGray
                                : theme.colors.secondaryLight};
                        `}
                    >
                        <ChangeLanguage />
                        <span className="ms-1 me-4">|</span>
                        {user.isLoggedIn && (
                            <>
                                <Button
                                    href="/dashboard"
                                    type="linkButton"
                                    color="secondary"
                                    size="small"
                                    backgroundColor="primary"
                                    style={
                                        'padding-right: 1rem; padding-left: 1rem;'
                                    }
                                >
                                    {t('dashboard')}
                                </Button>
                                <span className="mr-4 ml-4">|</span>
                                <Button
                                    href="/api/auth/signout"
                                    type="linkButton"
                                    color="lighterGray"
                                    size="small"
                                    backgroundColor="secondary"
                                    style={
                                        'padding-right: 1rem; padding-left: 1rem;'
                                    }
                                >
                                    {t('signout')}
                                </Button>
                            </>
                        )}
                        {!user.isLoggedIn && (
                            <Button
                                href="/auth/signin"
                                type="linkButton"
                                color="lighterGray"
                                size="small"
                                backgroundColor="secondary"
                                style={
                                    'padding-right: 1rem; padding-left: 1rem;'
                                }
                            >
                                {t('login')}
                            </Button>
                        )}
                    </div>
                </div>
                <div className="bg-white absolute"></div>
                <div
                    className={`hidden lg:flex 2xl:w-2/5 ${router.locale === 'en'
                        ? 'ml-auto lg:mr-10'
                        : 'mr-auto lg:ml-10'
                        }`}
                >
                    <ul className="flex w-full xl:justify-evenly capitalize flex-wrap">
                        <li className="mx-1">
                            <Link
                                href="/"
                                style={menuStyle}
                                hoverColor="lighterGray"
                                color="secondary"
                            >
                                {t('home')}
                            </Link>
                        </li>
                        <li className="mx-1">
                            <Link
                                href="/brokers"
                                style={menuStyle}
                                hoverColor="lighterGray"
                                color="secondary"
                            >
                                {t('brokers')}
                            </Link>
                        </li>
                        <li className="mx-1">
                            <Link
                                href="/charts"
                                style={menuStyle}
                                hoverColor="lighterGray"
                                color="secondary"
                            >
                                {t('charts')}
                            </Link>
                        </li>
                        <li className="mx-1">
                            <Link
                                href="/blog"
                                style={menuStyle}
                                hoverColor="lighterGray"
                                color="secondary"
                            >
                                {t('blog')}
                            </Link>
                        </li>
                        <li className="mx-1">
                            <Link
                                href="/about"
                                style={menuStyle}
                                hoverColor="lighterGray"
                                color="secondary"
                            >
                                {t('about us')}
                            </Link>
                        </li>
                        <li className="mx-1">
                            <Link
                                href="/contact"
                                style={menuStyle}
                                hoverColor="lighterGray"
                                color="secondary"
                            >
                                {t('contact us')}
                            </Link>
                        </li>
                    </ul>
                </div>

                <Link
                    href="/"
                    className={`lg:m-0 ${router.locale === 'en' ? 'ml-auto' : 'mr-auto'
                        }`}
                >
                    <Image
                        width="100"
                        height="40"
                        alt="logo"
                        src="/img/shared/logo.png"
                    />
                </Link>
            </header>
        </>
    )
}

export default Navbar
